export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["хв"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купити"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["за"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активно"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Посилання на оголошення"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID мейкера"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Опис"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Таймаут"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата створення"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Я заплачу"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Я отримаю"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ліміт угоди"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Усі"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Угоди"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID пропозиції"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курс"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть рахунок"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поза лімітом"])}
}